// core
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// campfire
import { PartnerBrandService } from '@campfire-nx/api';

// services
import { AuthService } from './auth.service';
import { environment } from '@open-portal-env';
import { QuoteService } from '@campfire-nx/api';


@Injectable({
  providedIn: 'root'
})
export class PortalRedirectService {

  constructor(
    private router: Router,
    private authService: AuthService,
    private partnerBrandService: PartnerBrandService,
    private quoteService: QuoteService
  ) { }

  bookAppointment(type?: string, payload?: { [key:string]: any }) {
    let product = this.partnerBrandService.getAttribute('product', 'partner');
    let partnerSlug = this.partnerBrandService.getAttribute('slug', 'partner');
    let apiKey = this.authService.getApiKey();
    let token = this.authService.getToken();
    let slug: any;
    let redirectLinkElements: Array<string> = [];
    const isPolicyView = this.router.url.indexOf('/policy/') > -1;
    const isHelpFlow = this.router.url.indexOf('/support') > -1;
    type = type || 'help';

    if (this.router.url.indexOf('/quote/') > -1) {
      type = 'raptor-quote';
      slug = this.router.url.split('/').pop();
    }

    redirectLinkElements = [
      environment.openPortal,
      '?key=',
      apiKey,
      '&pc=',
      product && product.slug,
      '&redirect=',
      window.location.href,
      '&redirectBack=',
      window.location.href,
      '&action=appointment'
    ];

    if (token) {
      redirectLinkElements.push('&jwt=' + token);
    }

    if (slug && product && apiKey) {
      // make sure the quote has not been bound yet
      this.quoteService.getBySlug(slug)
        .then(() => {
          redirectLinkElements.push('&qr=' + slug);
          window.open(redirectLinkElements.join(''), '_blank');
        })
        .catch(() => {
          window.open(redirectLinkElements.join(''), '_blank');
        });
    } else if (isPolicyView && !payload) {
      window.open(redirectLinkElements.join(''), '_blank');
    } else if ((isHelpFlow || isPolicyView) && payload) {
      const urlFriendlyPayload = encodeURIComponent(JSON.stringify(payload));
      
      window.open(
        [
          environment.openPortal,
          `?jwt=${token}`,
          `&partner=${partnerSlug}`,
          `&action=appointment`,
          `&payload=${urlFriendlyPayload}`,
          `&redirect=${window.location.href}`,
          `&redirectBack=${window.location.href}`,
          `&topic=${payload.topic}`,
          `&source=opv2${isHelpFlow ? '-helpflow' : '-policy'}`
        ].join(''),
        isHelpFlow ? '_self' : '_blank'
      )
    } else {
      window.open(
        environment.openPortal + '/booking/' + type + (slug ? '/' + slug : '') + '?partner=' + partnerSlug + (isHelpFlow ? '&source=opv2-helpflow' : ''),
        isHelpFlow ? '_self' : '_blank'
      );
    }
  }

  // Reasons: policy_update, new_claim, payment
  goToPortalV1(reason: string, policySlug: string, source?: string) {
    let apiKey = this.authService.getApiKey();
    let token = this.authService.getToken();
    let clientId = window.sessionStorage.getItem('clientId');
    const companyInfo = this.partnerBrandService.getAttribute('companyInfo', 'partner');

    let payload = {
      policy_slug: policySlug,
      [reason]: true,
      partner: this.partnerBrandService.data.partner.slug,
      source: `opv2${source ? '-' + source : ''}`
    }

    let urlFriendlyPayload = encodeURIComponent(JSON.stringify(payload));
    
    let redirectLink = [
      companyInfo.CUSTOM_MANAGEMENT_DOMAIN || environment.openPortal,
      `?key=${apiKey}`,
      `&redirect=${source === 'helpflow' ? `${window.location.origin}/support` : window.location.href}`,
      `&redirectBack=${source === 'helpflow' ? `${window.location.origin}/support` : window.location.href}`,
      '&action=dashboard',
      `&payload=${urlFriendlyPayload}`
    ]

    if (token) {
      redirectLink.push(`&jwt=${token}`);
    }

    if (clientId) {
      redirectLink.push(`&clientId=${clientId}`);
    }
    
    window.open(redirectLink.join(''), '_self');
  }
}
